module.exports = __webpack_public_path__ + "img/visa-parallax.42daba26.png";